import { DateTime } from 'luxon'
import Logo from 'icons/logo-cutilei-simple.png'
import { FaTimes } from 'react-icons/fa'

import {
  Container,
  Row,
  Image,
  SubTitle,
  InfoText,
  MoneyTextMask,
  Light
} from './styles'

export default function CutileiSchedule ({
  data: schedule,
  onClick: handleClick
}) {
  const scheduleDateTime = DateTime.fromFormat (`${schedule.date} ${schedule.time}`, 'yyyy-MM-dd H:mm')
  const isReservation = schedule.validated === undefined
  const isCompleted = DateTime.now () >= scheduleDateTime?.plus ({minutes: schedule.max_delay + 1})
  const isInProgress = !isCompleted && DateTime.now () > scheduleDateTime.minus ({minutes: 20})
  const isValidated = schedule.validated

  return (
    <Container onClick={() => handleClick (schedule)}>
      <Row>
        <Light
          isInProgress={isInProgress}
          isCompleted={isCompleted}
          isValidated={isValidated}
          isReservation={isReservation}
          cutileiSchedule={schedule.cutilei_schedule}
          status={schedule.status}
        >
          {schedule.canceled && <FaTimes color='#FFFFFF' size={12}/>}
        </Light>
        {schedule.cutilei_schedule && <Image src={Logo} alt='Agendamento Cutilei'/>}
        <SubTitle>
          {schedule.member?.name.split (' ')[0]}
        </SubTitle>
      </Row>
      <InfoText>
        {schedule.business.name}
      </InfoText>
      <InfoText>
        {schedule.service.name}
      </InfoText>
      <InfoText>
        {schedule.professional.nickname}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (schedule.date).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <InfoText>
        {schedule.time}
      </InfoText>
      <MoneyTextMask value={schedule.price} style={{justifySelf: 'center'}}/>
    </Container>
  )
}
